import {
  EditorReadyFn,
  FlowAPI,
  GetAppManifestFn,
  TFunction,
  FlowEditorSDK,
} from '@wix/yoshi-flow-editor';
import faqOOWidget from './components/FaqOoi/.component.json';

import { openDashboard } from './utils/openDashboard';
import ActionsId from './utils/ActionsId';
import { configureManifest } from './manifest';
import { ComponentRef } from '@wix/editor-platform-sdk-types';

const createBooleanStyleParam = (key: string, value: boolean) => ({
  type: 'boolean' as 'boolean',
  key,
  param: {
    value,
  },
});

const setStyleParamsForDevice = async (
  editorSDK: FlowEditorSDK,
  componentRef: ComponentRef,
  isEditor3: boolean,
) =>
  editorSDK.tpa.setStyleParams('token', {
    compRef: componentRef,
    styleParams: [createBooleanStyleParam('isEditor3', isEditor3)],
  });

export const editorReady: EditorReadyFn = async (
  editorSDK,
  appDefId,
  options,
  flowApi,
) => {
  if (options.firstInstall) {
    editorSDK.addEventListener('widgetAdded', async (event) => {
      const { detail } = event;
      const { componentRef } = detail;
      const isEditor3 = `${options.origin.subType}`.toLowerCase() === 'editor3';

      await setStyleParamsForDevice(editorSDK, componentRef, isEditor3).catch(
        (error: Error) => {
          console.error('Error setting style params for devices', {
            device: componentRef.type,
            componentRef,
            errorMessage: error.message,
            errorStack: error.stack,
            error,
          });
        },
      );

      await editorSDK.document.components.setFullWidth('token', {
        componentRef,
        fullWidth: options.origin.type === 'RESPONSIVE',
        margins: { left: { vw: 5 }, right: { vw: 5 } },
      });
    });
  }

  editorSDK.addEventListener('appActionClicked', (event) => {
    switch (event.detail.actionId) {
      case ActionsId.ADD_QUESTION:
        openDashboard(editorSDK, true);
        break;
      case ActionsId.MANAGE_FAQS:
        openDashboard(editorSDK, false, false);
        break;
      case ActionsId.ADD_CATEGORY:
        openDashboard(editorSDK, false, true);
        break;

      default:
        break;
    }
  });
};

export const getAppManifest: GetAppManifestFn = async (
  { appManifestBuilder },
  editorSDK,
  contextParams,
  flowAPI: FlowAPI,
) => {
  const { t } = flowAPI.translations as { t: TFunction };
  const { id } = faqOOWidget;

  appManifestBuilder.configureWidget(id, (widgetBuilder) => {
    widgetBuilder.set({
      displayName: t('app.widget.name'),
    });
    widgetBuilder.gfpp().set('stretch', {
      behavior: 'DEFAULT',
    });
    widgetBuilder.configureConnectedComponents((connectedComponentsBuilder) => {
      connectedComponentsBuilder.gfpp().set('stretch', { behavior: 'DEFAULT' });
    });
  });

  configureManifest(appManifestBuilder, editorSDK, t);

  return appManifestBuilder.build();
};
